// src/lib/countryConfig.ts
//
// Single lookup for everything that varies by school.country. New file —
// per Blueprint Section 11, existing files get at most one conditional
// branch added; all the actual per-country data lives here.
//
// Pakistan values below match today's hardcoded behavior exactly, so
// wiring any existing PKR/+92 site through this file changes nothing for
// Pakistani schools — it's a refactor of where the value lives, not a
// behavior change.

import type { CountryConfig } from './types';
import { PAKISTAN_CONFIG } from './pakistan/config';
import { NIGERIA_CONFIG } from './nigeria/config';

export type Country = 'pakistan' | 'nigeria';

export const COUNTRY_CONFIG: Record<Country, CountryConfig> = {
  pakistan: PAKISTAN_CONFIG,
  nigeria: NIGERIA_CONFIG,
};

export function getCountryConfig(country: Country | null | undefined): CountryConfig {
  return COUNTRY_CONFIG[country === 'nigeria' ? 'nigeria' : 'pakistan'];
}

// Centralized currency formatter — replaces the duplicated formatPKR()
// helpers in PrincipalFinance.tsx / AdminSubscriptions.tsx and the inline
// fmt() in ParentFees.tsx. Same output shape as today's Pakistan helpers
// (`Intl.NumberFormat` grouping + trailing currency code), so swapping
// existing call sites to this is a like-for-like replacement, not a
// display change, for Pakistan.
export function formatCurrency(amount: number, country: Country | null | undefined): string {
  const cfg = getCountryConfig(country);
  const locale = country === 'nigeria' ? 'en-NG' : 'en-PK';
  return `${new Intl.NumberFormat(locale).format(Math.round(amount))} ${cfg.currencySuffix}`;
}

export type { CountryConfig } from './types';
export type { ClassNamingScheme, Tier, ClassTemplateEntry } from './nigeria/classTemplates';
export { TIERS, TIER_INDEX, getNigeriaClassTemplates } from './nigeria/classTemplates';
